package net.bothosting.docs.pages.faqs_and_info

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initHow_to_write_a_support_requestPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("faqs_and_info/how_to_write_a_support_request.md", FrontMatterElement.Builder { addScalar("description", "Useful information to help you get a faster answer and make it easier for support to assist you."); }))
}

@Page("/faqs_and_info/how-to-write-a-support-request")
@Layout(".components.layouts.DocsLayout")
@Composable
fun How_to_write_a_support_requestPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("how-to-write-a-support-request") }) {
        org.jetbrains.compose.web.dom.Text("How to Write a Support Request")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("How quickly and effectively we can help with problems and questions depends heavily on ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("how you write your support requests.")
            }
        }
        org.jetbrains.compose.web.dom.Br()
        org.jetbrains.compose.web.dom.Br()
        org.jetbrains.compose.web.dom.Text("&#xNAN;")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("The more complete the information you provide, the fewer questions we need to ask and the faster we can find a solution for your issue. Imagine you are the one trying to help.")
        }
        org.jetbrains.compose.web.dom.Br()
        org.jetbrains.compose.web.dom.Br()
        org.jetbrains.compose.web.dom.Text("&#xNAN;")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("Ask the question in a way that you would want to read it.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("What we recommend you do:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Run your server")
            }
            org.jetbrains.compose.web.dom.Text(" before asking if it can work. ")
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("(Errors are often very useful for pinpointing the issue.)")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Explain what you tried to do to fix the problem.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Read")
            }
            org.jetbrains.compose.web.dom.Text(" the error and the responses you are given.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Post your full error.")
            }
            org.jetbrains.compose.web.dom.Text(" ")
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("(Provide the context you are working in.)")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Actively participate in the troubleshooting process. ")
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("(Do not expect people to fix the issue for you.)")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Check your information.")
            }
            org.jetbrains.compose.web.dom.Text(" If you are not entirely sure about something, please refrain from including it in the problem description.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Research keywords")
            }
            org.jetbrains.compose.web.dom.Text(" you do not understand before asking what they mean. ")
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("(Come back and ask if you cannot find them.)")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Staff is here to help you.")
            }
            org.jetbrains.compose.web.dom.Text(" If you believe that you know the issue better than support, you can feel free to investigate it yourself.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("Important note:")
        }
        org.jetbrains.compose.web.dom.Text(" We do not have anything like \"forwarding\" to another supporter here. Every staff member has experience with the issues they are helping you with, and if they do not know the issue, they will simply forward the ticket to another staff member. Because of that, we do not allow requests to change the person helping you.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.WARNING, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" The Support Team can refuse to help you if your request does not meet these requirements or lacks enough information for us to help you.")
        }
    }
}
